import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row"
    },
    footerContainer: {
        justifyContent: "flex-end",
        flexDirection: "column"
    },
    closeButton: {
        cursor: "pointer"
    },
    container: {
        maxWidth: "100%",
        width: 440
    },
    formContainer: {
        width: "100%"
    }
});
export default stylesheet;
